import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import ATLCodes from "../../data/atlCodes.json";
import { authFetch } from "../../utils/api";

const ATLTinkerpreneurRegistrationPopup = ({ year, filledATLInfo, data }) => {
  const [isOpen, setOpen] = useState(true);
  const [displayFields, setDisplayFields] = useState(false);
  const [handleHaveAtlLab, setHandleHaveAtlLabs] = useState("");
  const [atlCode, setAtlCode] = useState("");
  const [showError, setShowError] = useState(false);
  const [invalidAtlCode, setInvalidAtlCode] = useState(false);
  const [selectedState, setSelectedState] = useState("");

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("body-no-scroll");
    } else {
      document.body.classList.remove("body-no-scroll");
    }

    return () => {
      document.body.classList.remove("body-no-scroll");
    };
  }, [isOpen]);

  const submitTinkerpreneurRegistration = () => {
    const id = localStorage.getItem("studentId");
    authFetch(`${process.env.REACT_APP_API_URL}/users/students/` + id)
      .then((res) => res.json())
      .then((result) => {
        setSelectedState(result.data[0].state);
      });

    if (!filledATLInfo) {
      if (
        handleHaveAtlLab === "" ||
        (handleHaveAtlLab === "yes" && atlCode === "")
      ) {
        setShowError(true);
        return;
      }

      const acceptedAtlCodes = ATLCodes[selectedState] || [];
      if (!acceptedAtlCodes.includes(atlCode) && handleHaveAtlLab === "yes") {
        setInvalidAtlCode(true);
        setShowError(true);
        return;
      }
    }

    const token = localStorage.getItem("jwtToken");
    fetch(`${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/enroll`, {
      method: "POST",
      headers: {
        "x-access-token": token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        handleHaveAtlLab: handleHaveAtlLab,
        atlCode: atlCode,
        year: year,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        setOpen(false);
        window.location.href = `/tinkerpreneur-${year}`;
      });
  };

  return (
    isOpen && (
      <Popup
        trigger={<button style={{ display: "none" }}></button>}
        position="top center"
        open={isOpen}
        closeOnDocumentClick={false}
        overlayStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.80)",
          overflow: "hidden",
        }}
      >
        <div
          className="d-flex flex-column p-4 p-lg-5 rounded-3 shadow-lg"
          style={{ backgroundColor: "white" }}
        >
          <h2 className="mt-3 text-center">India AI Tinkerpreneur {year}</h2>
          <p className="text-center mb-2">
            <strong>
              Ready to join India's most exciting student AI Entrepreneurship
              program?
            </strong>
            <br />
          </p>
          {displayFields && (
            <div className="row mt-sm-3 p-0 px-lg-5">
              <div className="form-group col-12 mb-3">
                <label className="d-block mb-2">
                  Does your school have ATL Lab?
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hasAtlLab"
                    value="yes"
                    id="atlLabYes"
                    onChange={(e) => setHandleHaveAtlLabs(e.target.value)}
                    required
                  />
                  <label className="form-check-label" htmlFor="atlLabYes">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hasAtlLab"
                    value="no"
                    id="atlLabNo"
                    onChange={(e) => setHandleHaveAtlLabs(e.target.value)}
                    required
                  />
                  <label className="form-check-label" htmlFor="atlLabNo">
                    No
                  </label>
                </div>
                <div className="text-danger">
                  {showError &&
                    handleHaveAtlLab === "" &&
                    "Please choose on option."}
                </div>
              </div>
              {handleHaveAtlLab === "yes" && (
                <div className="form-group col-12 mb-3">
                  <label className="d-block mb-2">
                    {`ATL Code (`}
                    <small>
                      <a
                        href={`/assets/pdf/OperationalATLsInIndia.pdf`}
                        style={{ color: "#0048ff" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Click here
                      </a>
                      <span>&nbsp;to know ATL code!</span>
                    </small>
                    {`)`}
                  </label>
                  <input
                    onChange={(e) => setAtlCode(e.target.value)}
                    type="text"
                    name="atlCode"
                    className="form-control"
                    placeholder="ATL Code"
                  />
                  <small className="text-danger">
                    {showError && atlCode === "" && "ATL Code is required"}{" "}
                    {invalidAtlCode &&
                      showError &&
                      "Invalide ATL Code. Please fill valid ATL Code."}
                  </small>
                </div>
              )}
            </div>
          )}

          <div className="d-block text-center d-sm-flex justify-content-center w-100 gap-sm-3 mt-sm-3">
            {!displayFields && (
              <>
                <button
                  onClick={() => {
                    if (filledATLInfo) {
                      submitTinkerpreneurRegistration();
                    } else {
                      setDisplayFields(true);
                    }
                  }}
                  className="btn btn-primary rounded-3 px-4 py-2 text-white mb-2 mb-sm-0 mr-0 mr-sm-2"
                  style={{ minWidth: "140px" }}
                >
                  Enroll Now
                </button>

                <button
                  onClick={() => {
                    setOpen(false);
                    localStorage.setItem(
                      "showTinkerpreneurRegistrationPopUp",
                      false
                    );
                  }}
                  className="btn btn-secondary rounded-3 px-4 py-2"
                  style={{ minWidth: "140px" }}
                >
                  Close
                </button>
              </>
            )}
            {!filledATLInfo && displayFields && (
              <>
                <button
                  onClick={() => {
                    submitTinkerpreneurRegistration();
                  }}
                  className="btn btn-primary rounded-3 px-4 py-2 text-white mb-2 mb-sm-0 mr-0 mr-sm-2"
                  style={{ minWidth: "140px" }}
                >
                  Submit
                </button>

                <button
                  onClick={() => {
                    setOpen(false);
                    localStorage.setItem(
                      "showTinkerpreneurRegistrationPopUp",
                      false
                    );
                  }}
                  className="btn btn-secondary rounded-3 px-4 py-2"
                  style={{ minWidth: "140px" }}
                >
                  Cancel
                </button>
              </>
            )}
          </div>
        </div>
      </Popup>
    )
  );
};

export default ATLTinkerpreneurRegistrationPopup;
